<template>
  <div class="edge-server">
    <!-- <div class="back" @click="back"></div> -->
    <div class="ttt">
      <div class="es-top">
        <div class="es-top-item">
          <div class="es-bar">
            <div class="es-bar-l">
              <img src="../assets/image/cpu.png" />
              CPU核数
            </div>
            <div class="es-bar-r">{{ this.cpuData.CPU }}个</div>
          </div>
          <div class="es-bar">
            <div class="es-bar-l">
              <img src="../assets/image/neicun.png" />
              <span>内存</span>
            </div>
            <div class="es-bar-r">{{ this.cpuData.Memory }}</div>
          </div>
          <div class="es-bar">
            <div class="es-bar-l">
              <img src="../assets/image/cipan.png" />
              <span>磁盘容量</span>
            </div>
            <div class="es-bar-r">{{ this.cpuData.disk }}GB</div>
          </div>
        </div>
        <div class="es-top-item es-top-item-r">
          <div class="es-title only-title1">资源总览</div>
          <!-- <div id="es-usage"></div> -->
          <Resources :needData='this.resourceOverviewData' v-if="this.resourceOverviewData"></Resources>
        </div>
      </div>
      <div class="es-container">
        <div class="es-charts">
          <div class="es-title">CPU使用率</div>
          <div class="chart-container" id="cpu-chart1">
            <!-- <img src="../assets/image/c1.png" alt="" /> -->
            <Cpu :needData='this.cpuUsageData' v-if="this.cpuUsageData"></Cpu>
          </div>
        </div>
        <div class="es-charts">
          <div class="es-title">内存使用率</div>
          <div class="chart-container" id="cpu-chart2">
            <!-- <img src="../assets/image/c2.png" alt="" /> -->
            <Memory :needData='this.memoryUsageData' v-if='this.memoryUsageData'></Memory>
          </div>
        </div>
        <div class="es-charts">
          <div class="es-title">系统平均负载</div>
          <div class="chart-container" id="cpu-chart3">
            <!-- <img src="../assets/image/c3.png" alt="" /> -->
            <Load :needData='this.averageSystemloadData' v-if="this.averageSystemloadData"></Load>
          </div>
        </div>
        <div class="es-charts">
          <div class="es-title">磁盘读写速率</div>
          <div class="chart-container" id="cpu-chart4">
            <!-- <img src="../assets/image/c4.png" alt="" /> -->
            <Disk :needData='this.diskRateData' v-if="this.diskRateData"></Disk>
          </div>
        </div>
        <div class="es-charts">
          <div class="es-title">磁盘读写延迟</div>
          <div class="chart-container" id="cpu-chart5">
            <!-- <img src="../assets/image/c5.png" alt="" /> -->
            <Delay :needData='this.diskDelayData' v-if="this.diskDelayData"></Delay>
          </div>
        </div>
        <div class="es-charts">
          <div class="es-title">网络IO</div>
          <div class="chart-container" id="cpu-chart6">
            <!-- <img src="../assets/image/c6.png" alt="" /> -->
            <Io :needData='this.internetIOData' v-if="this.internetIOData"> </Io>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { 
//	cpuData ,
//	resourceOverview ,
//	cpuUsage,
//	memoryUsage,
//	averageSystemload,
//	diskRate,
//	diskDelay,
//	internetIO
} from "../api/serverApi";
import Resources from "../components/serve/resources";
import Io from "../components/serve/io";
import Delay from "../components/serve/delay";
import Disk from "../components/serve/disk";
import Load from "../components/serve/load";
import Memory from "../components/serve/memory";
import Cpu from "../components/serve/cpu";
export default {
  data() {
    return {
      cpuData: "", //cpu 数据
      resourceOverviewData:"",//资源总览
      cpuUsageData:"", //CPU使用率
      memoryUsageData:"", //内存使用率 
      averageSystemloadData:"", //系统平均负载
      diskRateData:"",//磁盘读写速率
      diskDelayData:"", //磁盘读写延迟
      internetIOData:"",//网络IO
    };
  },
  components: {
    Resources,
    Io,
    Delay,
    Disk,
    Load,
    Memory,

    Cpu,
  },
  created() {
    
    
  },
  mounted() {
    this.serverData();
  },
  methods: {
    // back() {
    //   this.$router.push({
    //     path: "/",
    //   });
    //   document.getElementById("iframe").contentWindow.MMAPI.show1(0);
    // },

    //数据
    serverData() {

      //CPU
//    cpuData().then((res) => {
//         console.log(res.data, "CPU数据");
        this.cpuData = {"CPU": 16, "Memory": '32GB', "disk": 1024};
//    });

      //资源总览
//    resourceOverview().then((res)=>{
//         console.log(res,'资源总览');
        this.resourceOverviewData = {"CPUrate": 3.65,"Diskrate": 340,"Memoryrate": 2667};
//    });

      //CPU使用率
//    cpuUsage().then((res)=>{
//         console.log(res,'CPU使用率');
        this.cpuUsageData = {
        "Curant":66.86,
        "Data1":["37.80","47.95","60.44","55.45","49.94", "41.72","51.40","44.70","55.28","58.27"],
        "DateTime": ["2022-07-19 17:10","2022-07-19 17:11","2022-07-19 17:12","2022-07-19 17:13","2022-07-19 17:14","2022-07-19 17:15","2022-07-19 17:16","2022-07-19 17:17","2022-07-19 17:18","2022-07-19 17:19"],
				"Max": "64.84",
				"Min": "7.04",
				"Mvg": "47.15"};
//    });

      //内存使用率 
//    memoryUsage().then((res)=>{
//         console.log(res,'内存使用率');
        this.memoryUsageData = {"List":[{"Used": "17.48",
						"name": "15:55",
						"total": 32,
						"unUsed": 14.52},
						{"Used": "19.87",
						"name": "16:25",
						"total": 32,
						"unUsed": 12.13
						},
						{"Used": "4.39",
						"name": "16:55",
						"total": 32,
						"unUsed": 27.61
						},
						{"Used": "17.75",
						"name": "17:25",
						"total": 32,
						"unUsed": 14.25
						}
        ],
        unUsed: {"Min": 17.4, "Max": 93.01, "Mvg": '46.06', "Curant": '28.76'},
				used: {"Min": '6.99', "Max": '82.60', "Mvg": '33.02', "Curant": '82.37'}
				}
//    });

      //系统平均负载
//    averageSystemload().then((res)=>{
//         console.log(res.data.Data1,res.data.DateTime,'系统平均负载');
        this.averageSystemloadData = {"Data1":['33.88', '44.87', '64.43', '35.38', '40.19', '53.58', '21.44', '66.57', '16.92', '32.21'],"DateTime":['2022-07-20 09:29', '2022-07-20 09:30', '2022-07-20 09:31', '2022-07-20 09:32', '2022-07-20 09:33', '2022-07-20 09:34', '2022-07-20 09:35', '2022-07-20 09:36', '2022-07-20 09:37', '2022-07-20 09:38'] ,"minute":{"Curant": "41.51","Max": "71.50","Min": "7.33","Mvg": "34.46"},};
//    });

      //磁盘读写速率
//    diskRate().then((res)=>{
//         console.log(res.data.Data1,res.data.Data2,res.data.DateTime,'磁盘读写速率');
        this.diskRateData = {"Data1":[501, 482, 536, 489, 534, 536, 493, 531, 531, 535],
														"Data2":[464, 452, 431, 451, 446, 470, 450, 465, 439, 464],
														"DateTime":['2022-07-20 09:35', '2022-07-20 09:36', '2022-07-20 09:37', '2022-07-20 09:38', '2022-07-20 09:39', '2022-07-20 09:40', '2022-07-20 09:41', '2022-07-20 09:42', '2022-07-20 09:43', '2022-07-20 09:44'],
														"tital_read": {"Curant": 518,"Max": 521,"Min": 491,"Mvg": 505},
														"tital_write": {"Curant": 470,"Max": 470,"Min": 432,"Mvg": 436}
														};
//    });

      //磁盘读写延迟
//    diskDelay().then((res)=>{
//         console.log(res.data.Data1,res.data.DateTime,'磁盘读写延迟');
        this.diskDelayData = {"_delay":{"Curant": "1.46",
															"Max": "3.97",
															"Min": "1.31",
															"Mvg": "2.58"},
															"Data1":['4.17', '1.51', '3.85', '2.79', '2.78', '1.35', '3.22', '3.34', '3.59', '3.55'],
                              "DateTime":['2022-07-20 09:38', '2022-07-20 09:39', '2022-07-20 09:40', '2022-07-20 09:41', '2022-07-20 09:42', '2022-07-20 09:43', '2022-07-20 09:44', '2022-07-20 09:45', '2022-07-20 09:46', '2022-07-20 09:47']
        };
//    });

      //网络IO
//    internetIO().then((res)=>{
//         console.log(res.data.Data1,res.data.Data2,res.data.DateTime,'网络IO');
        this.internetIOData = {"Data1": [488, 488, 486, 472, 480, 505, 480, 479, 501, 492],
															"Data2": [367, 384, 375, 388, 380, 375, 376, 357, 383, 377],
															"DateTime": ['2022-07-20 09:45', '2022-07-20 09:46', '2022-07-20 09:47', '2022-07-20 09:48', '2022-07-20 09:49', '2022-07-20 09:50', '2022-07-20 09:51', '2022-07-20 09:52', '2022-07-20 09:53', '2022-07-20 09:54'],
															"_read": {"Curant": 475,
																				"Max": 494,
																				"Min": 477,
																				"Mvg": 493},
															"_write": {
																"Curant": 353,
																"Max": 392,
																"Min": 366,
																"Mvg": 389
															}
        };
//    })
    },
  },
};
</script>


<style scoped>
* {
  box-sizing: border-box;
}
.edge-server {
  position: absolute;
  height: 100%;
  width: 100%;
  background: url("../assets/img/seaveBg.png") no-repeat;
  background-size: 100% 100%;
}
.back {
  width: 1.8vw;
  height: 3.6vh;
  position: absolute;
  background: url("../assets/img/back.png") no-repeat;
  right: 3.5vw;
  top: 6vh;
  cursor: pointer;
  z-index: 7;
}
.ttt {
  position: absolute;
  height: 76%;
  width: 94%;
  left: 3%;
  bottom: 12%;
}
.es-top {
  height: 16%;
  display: flex;
  justify-content: space-between;
  padding: 0.5%;
}

.es-top .es-top-item {
  width: 49%;
  height: 100%;
  border: 1px solid var(--huixian);
  border-radius: 6px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.es-container {
  height: 82.6%;
  margin-top: 0.5%;
}

.es-bar {
  width: 29%;
  height: 80%;
  background: url("../assets/image/item-kuang.png");
  background-size: 100% 100%;
  display: flex;
  align-items: center;
}

.es-bar-l {
  color: var(--weilan-50);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60%;
  border-right: 1px dashed var(--weilan-50);
  height: 60%;
}

.es-bar-r {
  color: var(--weilan);
  font-weight: bold;
  font-size: 1.2vw;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40%;
  font-family: SIMHEI;
}

.es-title {
  background: url("../assets/image/title-bg.png");
  background-size: 100% 100%;
  height: 2.3vh;
  width: 6.7vw;
  display: flex;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  color: var(--white);
  font-size: 0.8vw;
  padding-left: 0.6vw;
  font-family: SIMHEI;
}

.es-top-item-r {
  position: relative;
}

.only-title1 {
  width: 5vw;
  z-index: 1;
}

#es-usage {
  height: 100%;
  width: 100%;
}

.es-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-gap: 1.5vw;
  padding: 0.5%;
}

.es-charts {
  border: 1px solid var(--huixian);
  border-radius: 6px;
  position: relative;
}

.chart-container {
  height: calc(100% - 2.3vh);
  width: 100%;
  margin-top: 2.3vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chart-container img {
  width: 90%;
}
</style>

 